'use client';

import { c as _c } from "react/compiler-runtime";
import { FACTIII_TEMPLATES, type FactiiiTemplate } from '@shared/utils/helpers/addFactiii/templates';
import { LUCIDE } from '../../../utils/lucideIcons';
import { t, Tile } from './parts';
const TemplateTile = t0 => {
  const $ = _c(16);
  const {
    template,
    onPick
  } = t0;
  let t1;
  if ($[0] !== onPick || $[1] !== template) {
    t1 = () => onPick(template);
    $[0] = onPick;
    $[1] = template;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = LUCIDE[template.icon];
  let t3;
  if ($[3] !== t2) {
    t3 = <Tile icon={t2} />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== template.title) {
    t4 = <p className={t.label}>{template.title}</p>;
    $[5] = template.title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== template.blurb) {
    t5 = <p className={t.meta}>{template.blurb}</p>;
    $[7] = template.blurb;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="min-w-0 flex-1">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t6) {
    t7 = <button type="button" onClick={t1} className="flex h-full items-center gap-2.5 rounded-lg border border-ds-border-standard px-2.5 py-2 text-left transition-colors hover:border-ds-border-hover hover:bg-primary/5">{t3}{t6}</button>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};

/**
 * Step one: pick a starting point. A tile only prefills the form — it opens no
 * different screen and locks nothing out — so picking the wrong one costs a
 * click on Change, and Custom is just the tile that prefills nothing.
 */
const TemplateGallery = t0 => {
  const $ = _c(22);
  const {
    onPick
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== onPick) {
    const common = FACTIII_TEMPLATES.filter(_temp);
    const ai = FACTIII_TEMPLATES.filter(_temp2);
    t5 = "space-y-4";
    const t7 = common.map(template => <TemplateTile key={template.key} template={template} onPick={onPick} />);
    if ($[7] !== t7) {
      t6 = <div className="grid gap-1.5 sm:grid-cols-2">{t7}</div>;
      $[7] = t7;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    t3 = "space-y-1.5";
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <p className={`px-0.5 ${t.micro}`}>Powered by AI</p>;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t1 = "grid gap-1.5 sm:grid-cols-2";
    t2 = ai.map(template_0 => <TemplateTile key={template_0.key} template={template_0} onPick={onPick} />);
    $[0] = onPick;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[10] !== t1 || $[11] !== t2) {
    t7 = <div className={t1}>{t2}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t7) {
    t8 = <div className={t3}>{t4}{t7}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className={`text-center ${t.meta}`}>Whichever you pick, everything stays optional and editable on the next screen.</p>;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t8) {
    t10 = <div className={t5}>{t6}{t8}{t9}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t8;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
export default TemplateGallery;
function _temp(tpl) {
  return tpl.section === "COMMON";
}
function _temp2(tpl_0) {
  return tpl_0.section === "AI";
}